<template>
  <rum-input ref="address" id="address"/>
</template>

<script>
export default {
  name: "RumieAddress",
  props: ['value'],
  data() {
    return {
      setupDone: false,
    };
  },
  methods: {
    configure() {
      const input = this.$refs.address.$refs.input;
      this.autocomplete = new window.google.maps.places.Autocomplete(input);
      this.autocomplete.setFields(["address_components", "geometry", "name"]);
      this.autocomplete.addListener("place_changed", this.onPlaceChange);
    },
    onPlaceChange() {
      const place = this.autocomplete.getPlace();
      if (place.address_components) {
        const address = [
          (place.name || ""),
          (place.address_components[0] &&
            place.address_components[0].short_name) ||
            "",
          (place.address_components[1] &&
            place.address_components[1].short_name) ||
            "",
          (place.address_components[2] &&
            place.address_components[2].short_name) ||
            "",
          (place.address_components[3] &&
            place.address_components[3].short_name) ||
            "",
          (place.address_components[4] &&
            place.address_components[4].short_name) ||
            ""
        ].join(" ");

        this.$emit("input", address);
      }
    }
  },
  watch: {
    value(value) {
      if (value && !this.setupDone) {
        this.$refs.address.$refs.input.value = value;
        this.setupDone = true;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.configure();
    })
  }
};
</script>

<style scoped>
</style>
